import * as React from "react";
export default function useModalState() {
  const [visible, _setInner] = React.useState(false);
  const onClose = React.useCallback(() => {
    _setInner(false);
  }, []);
  const onOpen = React.useCallback(() => {
    _setInner(true);
  }, []);
  return {
    visible,
    onClose,
    onOpen,
  };
}
